export class Product {
  _id: string;
  name: string;
  identifier: string;
  description: string;
  classificationIdentifier: string;
  classificationName: string;
  periodicity: string;
  category: string;
  value: number;
  valueFormatted: string;
  automaticRecharge: number;
  automaticRechargeOnly: boolean;
  externalCode: string;
  
  isRecommended: boolean;
  periodicityValue: number;

  upgradePaymentDescription: string;
  hasBalance: boolean;
  
  constructor(productData: any) {
    this._id = productData._id;
    this.name = productData.name;
    this.identifier = productData.identifier;
    this.classificationIdentifier = productData.classificationIdentifier;
    this.classificationName = productData.classificationName;
    this.periodicity = productData.periodicity;
    this.description = productData.description;
    this.isRecommended = false;
    this.category = productData.category;
    this.value = productData.value;
    this.externalCode = productData.externalCode;
    this.periodicityValue = productData.periodicityValue;
    this.automaticRecharge = productData.automaticRecharge;
    this.automaticRechargeOnly = productData.automaticRechargeOnly;
    this.upgradePaymentDescription = productData.upgradePaymentDescription;
    this.valueFormatted = this.formatValue(this.value);
    this.hasBalance = productData.hasBalance;
  }

  formatValue(value: number) {
    return Number(value).toFixed(2).replace(".", ",");
  }
}
